import { EFontFamilies } from "@/shared/theme/theme";
import { FormHelperText as MuiFormHelperText, styled } from "@mui/material";
export interface IMxErrorMessageProps {
  error: string | string[];
}
const MxErrorMessage = (props: IMxErrorMessageProps) => {
  return (
    <FormHelperText color="error.main">
      {props.error instanceof Array ? props.error.join(", ") : props.error}
    </FormHelperText>
  );
};

export default MxErrorMessage;

const FormHelperText = styled(MuiFormHelperText)(({ theme }) => ({
  transition: "all 0.2s ease-in-out",
  color: theme.palette.error.main + " !important",
  fontFamily: EFontFamilies.DISPLAY,
  fontSize: theme.typography.pxToRem(13),
  lineHeight: 1.2
}));
